export default "__VITE_ASSET__BoZFdlLP__"